/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DamageAssessorPricing } from '../models';
/**
 * DamageassessorpricingApi - axios parameter creator
 * @export
 */
export const DamageassessorpricingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all DamageAssessorPricing
         * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingGet: async (offset?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/damageassessorpricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the DamageAssessorPricing by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damageassessorpricingIdDelete', 'id', id)
            const localVarPath = `/damageassessorpricing/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the DamageAssessorPricing by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damageassessorpricingIdGet', 'id', id)
            const localVarPath = `/damageassessorpricing/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific DamageAssessorPricing
         * @param {number} id 
         * @param {DamageAssessorPricing} [damageAssessorPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingIdPut: async (id: number, damageAssessorPricing?: DamageAssessorPricing, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damageassessorpricingIdPut', 'id', id)
            const localVarPath = `/damageassessorpricing/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageAssessorPricing, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Level 1 DamageAssessorPricing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingL1pricingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/damageassessorpricing/l1pricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Post DamageAssessorPricing
         * @param {DamageAssessorPricing} [damageAssessorPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingPost: async (damageAssessorPricing?: DamageAssessorPricing, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/damageassessorpricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageAssessorPricing, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update DamageAssessorPricing
         * @param {DamageAssessorPricing} [damageAssessorPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingPut: async (damageAssessorPricing?: DamageAssessorPricing, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/damageassessorpricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageAssessorPricing, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DamageassessorpricingApi - functional programming interface
 * @export
 */
export const DamageassessorpricingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DamageassessorpricingApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all DamageAssessorPricing
         * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorpricingGet(offset?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DamageAssessorPricing>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorpricingGet(offset, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete the DamageAssessorPricing by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorpricingIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorpricingIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the DamageAssessorPricing by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorpricingIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageAssessorPricing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorpricingIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific DamageAssessorPricing
         * @param {number} id 
         * @param {DamageAssessorPricing} [damageAssessorPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorpricingIdPut(id: number, damageAssessorPricing?: DamageAssessorPricing, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageAssessorPricing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorpricingIdPut(id, damageAssessorPricing, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Level 1 DamageAssessorPricing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorpricingL1pricingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DamageAssessorPricing>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorpricingL1pricingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Post DamageAssessorPricing
         * @param {DamageAssessorPricing} [damageAssessorPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorpricingPost(damageAssessorPricing?: DamageAssessorPricing, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageAssessorPricing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorpricingPost(damageAssessorPricing, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update DamageAssessorPricing
         * @param {DamageAssessorPricing} [damageAssessorPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorpricingPut(damageAssessorPricing?: DamageAssessorPricing, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageAssessorPricing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorpricingPut(damageAssessorPricing, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DamageassessorpricingApi - factory interface
 * @export
 */
export const DamageassessorpricingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DamageassessorpricingApiFp(configuration)
    return {
        /**
         * Get all DamageAssessorPricing
         * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingGet(offset?: number, size?: number, options?: any): AxiosPromise<Array<DamageAssessorPricing>> {
            return localVarFp.damageassessorpricingGet(offset, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the DamageAssessorPricing by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.damageassessorpricingIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the DamageAssessorPricing by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingIdGet(id: number, options?: any): AxiosPromise<DamageAssessorPricing> {
            return localVarFp.damageassessorpricingIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific DamageAssessorPricing
         * @param {number} id 
         * @param {DamageAssessorPricing} [damageAssessorPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingIdPut(id: number, damageAssessorPricing?: DamageAssessorPricing, options?: any): AxiosPromise<DamageAssessorPricing> {
            return localVarFp.damageassessorpricingIdPut(id, damageAssessorPricing, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Level 1 DamageAssessorPricing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingL1pricingGet(options?: any): AxiosPromise<Array<DamageAssessorPricing>> {
            return localVarFp.damageassessorpricingL1pricingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Post DamageAssessorPricing
         * @param {DamageAssessorPricing} [damageAssessorPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingPost(damageAssessorPricing?: DamageAssessorPricing, options?: any): AxiosPromise<DamageAssessorPricing> {
            return localVarFp.damageassessorpricingPost(damageAssessorPricing, options).then((request) => request(axios, basePath));
        },
        /**
         * Update DamageAssessorPricing
         * @param {DamageAssessorPricing} [damageAssessorPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorpricingPut(damageAssessorPricing?: DamageAssessorPricing, options?: any): AxiosPromise<DamageAssessorPricing> {
            return localVarFp.damageassessorpricingPut(damageAssessorPricing, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DamageassessorpricingApi - object-oriented interface
 * @export
 * @class DamageassessorpricingApi
 * @extends {BaseAPI}
 */
export class DamageassessorpricingApi extends BaseAPI {
    /**
     * Get all DamageAssessorPricing
     * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
     * @param {number} [size] How many items to return at one time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorpricingApi
     */
    public damageassessorpricingGet(offset?: number, size?: number, options?: AxiosRequestConfig) {
        return DamageassessorpricingApiFp(this.configuration).damageassessorpricingGet(offset, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the DamageAssessorPricing by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorpricingApi
     */
    public damageassessorpricingIdDelete(id: number, options?: AxiosRequestConfig) {
        return DamageassessorpricingApiFp(this.configuration).damageassessorpricingIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the DamageAssessorPricing by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorpricingApi
     */
    public damageassessorpricingIdGet(id: number, options?: AxiosRequestConfig) {
        return DamageassessorpricingApiFp(this.configuration).damageassessorpricingIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific DamageAssessorPricing
     * @param {number} id 
     * @param {DamageAssessorPricing} [damageAssessorPricing] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorpricingApi
     */
    public damageassessorpricingIdPut(id: number, damageAssessorPricing?: DamageAssessorPricing, options?: AxiosRequestConfig) {
        return DamageassessorpricingApiFp(this.configuration).damageassessorpricingIdPut(id, damageAssessorPricing, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Level 1 DamageAssessorPricing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorpricingApi
     */
    public damageassessorpricingL1pricingGet(options?: AxiosRequestConfig) {
        return DamageassessorpricingApiFp(this.configuration).damageassessorpricingL1pricingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Post DamageAssessorPricing
     * @param {DamageAssessorPricing} [damageAssessorPricing] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorpricingApi
     */
    public damageassessorpricingPost(damageAssessorPricing?: DamageAssessorPricing, options?: AxiosRequestConfig) {
        return DamageassessorpricingApiFp(this.configuration).damageassessorpricingPost(damageAssessorPricing, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update DamageAssessorPricing
     * @param {DamageAssessorPricing} [damageAssessorPricing] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorpricingApi
     */
    public damageassessorpricingPut(damageAssessorPricing?: DamageAssessorPricing, options?: AxiosRequestConfig) {
        return DamageassessorpricingApiFp(this.configuration).damageassessorpricingPut(damageAssessorPricing, options).then((request) => request(this.axios, this.basePath));
    }
}
